import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Button, Form, Input, Alert} from 'antd';
import request from 'superagent';
import CryptoJS from 'crypto-js';
import Constants from '../../commons/Constants.js';
import {getUrl} from "../../commons/CommonUtils.js";
import NotificationManager from '../../commons/CustomNotificationManager.js';
import non from 'nonce';

const FormItem = Form.Item;

class ChangePwdModalForm extends Component {

    state = {
        loading: false,
        visible: false,
        confirmDirty: false,
        status: Constants.STATUS.init,
        errorMessage:''
    }

    showModal = () => {
        this.props.form.resetFields();
        this.setState({
            loading: false,
            visible: true,
            status: Constants.STATUS.init,
            errorMessage: ''
        });
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({loading: true});
                this.getEncryptedPasswords(values.oldPwd, values.newPwd)
                    .then(response => {
                        const encPwd = response.body;
                        const uuid = sessionStorage.getItem('uuid');
                        const url = getUrl(Constants.Service.localUser, "/" + uuid + "/password");
                        request.put(url)
                            .withCredentials()
                            .send({
                                "oldPassword": encPwd.oldEnc,
                                "newPassword": encPwd.newEnc
                            })
                            .end((error, response) => {
                                if (!error && response) {
                                    console.log('Succeed to change password.');
                                    NotificationManager.success("Succeed to change password.");
                                    this.props.form.resetFields();
                                    this.setState({loading: false, visible: false});
                                } else {
                                    console.log("failed to change password.");
                                    this.setState({loading: false});
                                    if (error.status === 403 || error.status === 400) {
                                        this.setState({status: Constants.STATUS.error});
                                        this.setState({errorMessage: "The Current Password is invalid. Please reenter the Current Password."});
                                    } else {
                                        this.setState({status: Constants.STATUS.error});
                                        this.setState({errorMessage: "Unexpected exception, Please connect to admin."});
                                    }
                                }
                            })
                    }).catch(err => {
                        this.setState({loading: false, errorMessage: 'Failed to change password.'});
                        console.error(err);
                    });
            }
        });

    }

    getEncryptedPasswords = (oldPwd, newPwd) => {
        const secret = non()().toString();

        const key = CryptoJS.PBKDF2(
            sessionStorage.getItem('username'), secret, {
                hasher: CryptoJS.algo.SHA256,
                keySize: 128,
                iterations: 32
            });
        const iv = CryptoJS.PBKDF2(
            sessionStorage.getItem('uuid'), secret, {
                hasher: CryptoJS.algo.SHA256,
                keySize: 128,
                iterations: 32
            });
        const inputOldEnc = CryptoJS.AES.encrypt(oldPwd, key, {
            mode: CryptoJS.mode.CFB,
            padding: CryptoJS.pad.Pkcs7,
            iv: iv
        }).toString();
        const inputNewEnc = CryptoJS.AES.encrypt(newPwd, key, {
            mode: CryptoJS.mode.CFB,
            padding: CryptoJS.pad.Pkcs7,
            iv: iv
        }).toString();

        return request.put('/api/getEncryptPassword').withCredentials()
            .send({
                "username": sessionStorage.getItem('username'),
                "uuid": sessionStorage.getItem('uuid'),
                "newPwd": inputNewEnc,
                "oldPwd": inputOldEnc,
                "s": secret
            }).then(resp => {
                return resp;
            })
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPwd')) {
            callback('Two passwords that you enter is inconsistent.');
        } else {
            callback();
        }
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['reNewPwd'], { force: true });
        }
        callback();
    }

    render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const { visible, loading } = this.state;

        return (
            <div>
                <a href="#" onClick={this.showModal}>{t("PASSWORD.CHANGE_PASSWORD")}</a>

                <Modal visible={visible} title={t("PASSWORD.CHANGE_PASSWORD")} onOk={this.handleOk} onCancel={this.handleCancel} maskClosable={false}
                    footer={[
                        <Button key="submit" type="primary" size="large" loading={loading} onClick={this.handleOk}>Save</Button>,
                        <Button key="back" size="large" onClick={this.handleCancel}>Cancel</Button>,
                    ]}>

                    <div>
                        <Alert style={{ display: this.state.status === Constants.STATUS.error ? 'block' : 'none' }}
                               message={this.state.errorMessage} type="error" showIcon/>
                    </div>

                    <div style={{margin: 20}}>
                        <Form>
                            <FormItem {...formItemLayout} label="Current Password" hasFeedback>
                                {getFieldDecorator('oldPwd', {
                                    rules: [{
                                        required: true, message: 'Please input your current password.',
                                    }, {
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!$%@^&*()_+|~=`\\#{}\[\]:";\'<>?,.\/]).{8,32}$/,
                                        message: 'Please enter a password which between 8 and 32 characters and contains at least one uppercase, one lowercase, one numeric and one special character.',
                                    }],
                                })(
                                    <Input type="password" />
                                )}
                            </FormItem>

                            <FormItem {...formItemLayout} label="New Password" hasFeedback>
                                {getFieldDecorator('newPwd', {
                                    rules: [{
                                        required: true, message: 'Please input your new password.',
                                    }, {
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!$%@^&*()_+|~=`\\#{}\[\]:";\'<>?,.\/]).{8,32}$/,
                                        message: 'Please enter a password which between 8 and 32 characters and contains at least one uppercase, one lowercase, one numeric and one special character.',
                                    }, {
                                        validator: this.checkConfirm,
                                    }],
                                })(
                                    <Input type="password" />
                                )}
                            </FormItem>

                            <FormItem {...formItemLayout} label="Confirm Password" hasFeedback>
                                {getFieldDecorator('reNewPwd', {
                                    rules: [{
                                        required: true, message: 'Please confirm your password.',
                                    }, {
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!$%@^&*()_+|~=`\\#{}\[\]:";\'<>?,.\/]).{8,32}$/,
                                        message: 'Please enter a password which between 8 and 32 characters and contains at least one uppercase, one lowercase, one numeric and one special character.',
                                    }, {
                                        validator: this.checkPassword,
                                    }],
                                })(
                                    <Input type="password" onBlur={this.handleConfirmBlur} />
                                )}
                            </FormItem>

                        </Form>
                    </div>

                </Modal>
            </div>
        );
    }
}
const ChangePwdModalAnt = Form.create()(ChangePwdModalForm);
export default translate()(ChangePwdModalAnt);


// WEBPACK FOOTER //
// ./src/modules/main/ChangePwdModalAnt.js